export const breakpoints = ['576px', '856px', '1160px'];

export const breakpointsRaw = breakpoints.map((e) => parseInt(e));
